import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { StyleSheetManager } from 'styled-components';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from '../elementos/basicos/Header';
import Footer from '../elementos/basicos/Footer';
import CabeceraCursos from '../elementos/basicos/Cabecera';
import { AreasContext } from '../../peticiones_API/Peticiones_Areas';

const API_URL = process.env.REACT_APP_API_URL;

const Areas = () => {
  const { areas, cargaAreas, errorAreas } = useContext(AreasContext);

  const renderTarjeta = (area) => (
    <Columna lg="4" md="6" sm="12" key={area.id}>
      <TarjetaLink to={`/areas/${area.slug}`}>
        <Tarjeta>
          <Media>
            {area.imagenUrl
              ? <img src={`${API_URL}${area.imagenUrl}`} alt={area.nombre} loading="lazy" />
              : <Placeholder><span>{area.nombre}</span></Placeholder>}
          </Media>
          <Etiqueta>{area.nombre.toUpperCase()}</Etiqueta>
        </Tarjeta>
      </TarjetaLink>
    </Columna>
  );

  const renderContenido = () => {
    if (cargaAreas) {
      return (
        <Row className="justify-content-center">
          {Array.from({ length: 6 }).map((_, i) => (
            <Columna lg="4" md="6" sm="12" key={`sk-${i}`}>
              <Tarjeta as="div">
                <Media><Skeleton /></Media>
                <EtiquetaSkeleton />
              </Tarjeta>
            </Columna>
          ))}
        </Row>
      );
    }
    if (errorAreas) {
      return (
        <Centrado>
          <p>No se pudieron cargar las áreas. Vuelve a intentarlo en unos minutos.</p>
          <BotonReintentar onClick={() => window.location.reload()}>Reintentar</BotonReintentar>
        </Centrado>
      );
    }
    if (!areas || areas.length === 0) {
      return (
        <Centrado>
          <p>Pronto añadiremos nuevas áreas formativas. Vuelve más tarde.</p>
        </Centrado>
      );
    }
    return <Row className="justify-content-center">{areas.map(renderTarjeta)}</Row>;
  };

  return (
    <>
      <Helmet>
        <title>Áreas formativas | TusCursosSepe</title>
        <meta name="description" content="Explora las áreas formativas con cursos gratuitos subvencionados." />
      </Helmet>
      <Header />
      <StyleSheetManager shouldForwardProp={() => true}>
        <CabeceraCursos
          Titulo="ÁREAS FORMATIVAS"
          Subtitulo="ENCUENTRA TU ÁREA"
          Texto_1="Explora nuestras áreas formativas y descubre los cursos gratuitos subvencionados de cada una."
          Texto_2="Elige el área que mejor encaje con tu objetivo profesional."
          color_cabecera="true"
        />
      </StyleSheetManager>

      <Seccion>
        <Container>{renderContenido()}</Container>
      </Seccion>

      <Footer />
    </>
  );
};

const Seccion = styled.div`
  padding: 3% 0 5%;
  min-height: 40vh;
`;

const Columna = styled(Col)`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
`;

const TarjetaLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  width: 100%;
  max-width: 22rem;
`;

const Tarjeta = styled.div`
  display: block;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.18);
  }
`;

const Media = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #f1f1f1;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ececec;
  padding: 1rem;
  text-align: center;

  span {
    font-family: 'Montserrat', sans-serif;
    font-size: 0.95rem;
    font-weight: 600;
    color: #8a8a8a;
    text-transform: capitalize;
  }
`;

const Etiqueta = styled.div`
  padding: 1rem;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: #333;
  letter-spacing: 0.3px;
`;

const Centrado = styled.div`
  text-align: center;
  padding: 6vh 1rem;
  font-family: 'Montserrat', sans-serif;
  color: #666;

  p { font-size: 1.05rem; margin-bottom: 1.2rem; }
`;

const BotonReintentar = styled.button`
  border: none;
  background: #ee805d;
  color: #fff;
  font-weight: 600;
  padding: 0.6rem 1.6rem;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  &:hover { opacity: 0.9; }
`;

const Skeleton = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #eee 25%, #f5f5f5 37%, #eee 63%);
  background-size: 400% 100%;
  animation: shimmer 1.4s ease infinite;

  @keyframes shimmer {
    0% { background-position: 100% 0; }
    100% { background-position: -100% 0; }
  }
`;

const EtiquetaSkeleton = styled.div`
  height: 1.2rem;
  margin: 1rem;
  border-radius: 4px;
  background: #eee;
`;

export default Areas;
